import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/midnight-lab.css';

function FRCHero() {
  return (
    <section style={{
      position: 'relative',
      minHeight: '70vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 'var(--space-24) var(--space-4)',
      paddingTop: '100px',
      overflow: 'hidden',
      backgroundColor: 'var(--color-bg-primary)'
    }}>

      <div style={{
        position: 'relative',
        zIndex: 2,
        maxWidth: '1200px',
        width: '100%',
        textAlign: 'center'
      }}>
        <div style={{
          display: 'inline-block',
          padding: 'var(--space-2) var(--space-6)',
          backgroundColor: 'var(--color-bg-secondary)',
          borderRadius: '0',
          border: '1px solid rgba(0, 16, 17, 0.1)',
          marginBottom: 'var(--space-6)',
          fontFamily: 'var(--font-sans)',
          fontSize: 'var(--text-xs)',
          fontWeight: 600,
          color: 'var(--color-text-primary)',
          textTransform: 'uppercase',
          letterSpacing: '1px'
        }}>
          FIRST Robotics Competition
        </div>

        <h1 className="heading-1" style={{
          marginBottom: 'var(--space-6)',
          color: 'var(--color-text-primary)'
        }}>
          FRC Division
        </h1>

        <p style={{
          fontSize: 'clamp(1.125rem, 2vw, 1.5rem)',
          marginBottom: 'var(--space-8)',
          fontWeight: 300,
          lineHeight: 1.7,
          color: 'var(--color-text-secondary)',
          fontFamily: 'var(--font-sans)',
          maxWidth: '800px',
          margin: '0 auto var(--space-8)'
        }}>
          We're building our FRC program from the ground up. Join us as we expand into 
          the world of 120lb robots and take on the ultimate robotics challenge.
        </p>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: 'var(--space-6)',
          maxWidth: '800px',
          margin: '0 auto var(--space-8)'
        }}>
          <div>
            <div style={{
              fontFamily: 'var(--font-sans)',
              fontSize: 'var(--text-4xl)',
              fontWeight: 700,
              color: 'var(--color-text-primary)',
              marginBottom: 'var(--space-2)'
            }}>
              2025
            </div>
            <div style={{
              fontFamily: 'var(--font-sans)',
              fontSize: 'var(--text-sm)',
              color: 'var(--color-text-secondary)',
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}>
              Launch Year
            </div>
          </div>
          <div>
            <div style={{
              fontFamily: 'var(--font-sans)',
              fontSize: 'var(--text-4xl)',
              fontWeight: 700,
              color: 'var(--color-text-primary)',
              marginBottom: 'var(--space-2)'
            }}>
              4
            </div>
            <div style={{
              fontFamily: 'var(--font-sans)',
              fontSize: 'var(--text-sm)',
              color: 'var(--color-text-secondary)',
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}>
              Subteams
            </div>
          </div>
          <div>
            <div style={{
              fontFamily: 'var(--font-sans)',
              fontSize: 'var(--text-4xl)',
              fontWeight: 700,
              color: 'var(--color-text-primary)',
              marginBottom: 'var(--space-2)'
            }}>
              Rookie
            </div>
            <div style={{
              fontFamily: 'var(--font-sans)',
              fontSize: 'var(--text-sm)',
              color: 'var(--color-text-secondary)',
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}>
              Year Goal
            </div>
          </div>
        </div>

        <Link
          to="/join"
          style={{
            display: 'inline-block',
            marginTop: 'var(--space-6)',
            padding: '14px 32px',
            backgroundColor: 'var(--color-text-primary)',
            color: 'var(--color-text-light)',
            fontSize: 'var(--text-base)',
            fontWeight: 600,
            letterSpacing: '1px',
            textTransform: 'uppercase',
            textDecoration: 'none',
            borderRadius: '0',
            transition: 'all var(--transition-base)',
            fontFamily: 'var(--font-sans)',
            border: '2px solid var(--color-text-primary)'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = 'var(--color-frozen-lake)';
            e.target.style.borderColor = 'var(--color-frozen-lake)';
            e.target.style.color = 'var(--color-text-primary)';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = 'var(--color-text-primary)';
            e.target.style.borderColor = 'var(--color-text-primary)';
            e.target.style.color = 'var(--color-text-light)';
          }}
        >
          Join FRC Team
        </Link>
      </div>
    </section>
  );
}

export default FRCHero;

